var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.openLoginPage)?_c('app-login-page',{attrs:{"type":_vm.type,"guestMode":_vm.openLoginPage,"mandatory":_vm.mandatory},on:{"onLogin":_vm.onLogin,"closeLoginPage":_vm.closeLoginPage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }